import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
    state:{
        distAll:[],
    },
    mutations:{
      //变更字典值
      DISTALL(state,distData){
          state.distAll=distData
      },
    },
  })
  export default store


// WEBPACK FOOTER //
// ./src/store/index.js